import React from 'react';
import { MockService, MockServiceEndpoint } from '../../types/rest/mockServiceTypes';
import _ from 'lodash';
import CopyToClipboardButton from '../buttons/CopyToClipboardButton';
import i18n from 'i18next';
import BzmIcon from '../icons/BzmIcon';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import styles from '../../views/MockServices/Tabs/MockServices/MockServicesListBlazeTable.module.css';

interface EndpointValueProps {
  endpoints: MockServiceEndpoint[];
}

const EndpointValue = ({ endpoints }: EndpointValueProps) => {
  const getMultipleEndpointsList = (endpoints: MockServiceEndpoint[]) =>
    _.map(endpoints, (endpoint: MockServiceEndpoint, index: number) => (
      <li key={index} className="mb-2">
        <div className={styles.showCopyParent}>
          {endpoint.runnerType && (
            <strong title={endpoint.runnerSubType} className={'mr-2'}>
              {endpoint.runnerType}
            </strong>
          )}
          {endpoint.endpoint}
          <CopyToClipboardButton
            textToCopy={endpoint.endpoint}
            title={i18n.t('mockServices:mockServicesTable.copyMockServiceEndpoint')}
            id={`mockServiceEndpointCopyButton` + index}
          >
            <BzmIcon variant={'icon-bzm-copy'}></BzmIcon>
          </CopyToClipboardButton>
        </div>
      </li>
    ));

  const getSingleEndpoint = (msEndpoint: MockServiceEndpoint) => {
    const endpoint = msEndpoint.endpoint; // Assuming service.endpoints is an object with an array of endpoints
    return (
      <>
        <span className={'text-truncate'}>{endpoint}</span>
        <div>
          <div className="flex-table-actions ml-2">
            <CopyToClipboardButton
              className={'p-0'}
              textToCopy={endpoint}
              title={i18n.t('mockServices:mockServicesTable.copyMockServiceEndpoint')}
              id={`mockServiceEndpointCopyButton` + msEndpoint.runnerType}
            >
              <BzmIcon variant={'icon-bzm-copy'} className={'text-blue'}></BzmIcon>
            </CopyToClipboardButton>
          </div>
        </div>
      </>
    );
  };

  const getEndpointsPopover = (msEndpoints: MockServiceEndpoint[]) => {
    const popover = (
      <Popover className={styles.popoverUnlimited} id={'qa-popover-endpoints'}>
        <ul className="list-unstyled mb-0 p-4">{getMultipleEndpointsList(msEndpoints)}</ul>
      </Popover>
    );
    return (
      <OverlayTrigger rootClose={true} trigger="click" placement="auto" overlay={popover}>
        <button
          title={'Multiple endpoints available'}
          className={'btn btn-link p-0 text-truncate'}
          onClick={(event: any) => event.preventDefault()}
        >
          Endpoints ({_.size(msEndpoints) || 0})
        </button>
      </OverlayTrigger>
    );
  };

  if (!endpoints || _.size(endpoints) === 0) {
    return <span>-</span>;
  }

  const isSingleEndpoint = endpoints && _.size(endpoints) === 1;
  const endpointValue = isSingleEndpoint ? getSingleEndpoint(endpoints[0]) : getEndpointsPopover(endpoints);

  return <div className={'d-flex flex-row'}>{endpointValue}</div>;
};

export default EndpointValue;
